<template>
  <v-dialog
    v-model="navigation.dialogIsVisible"
    @update:model-value="navigation.dialogIsVisible == false ? closeDialog() : null"
    @contextmenu.prevent="null"
    :max-width="navigation.fullScreen ? '100vw' : '70vw'"
    :fullscreen="navigation.fullScreen"
    :retain-focus="false"
    scrim="black"
    opacity="0.8"
    style="user-select: none; cursor: default;"
  >
    <v-card 
      :style="navigation.fullScreen ? 'min-height: 100vh; height: 100vh; max-height: 100vh;' : (loader.startup ? 'min-height: 80vh; height: 80vh; max-height: 80vh;' : 'min-height: 0; height: auto; max-height: 80vh;')"
      style="display: flex; flex-direction: column; overflow: hidden;"
    >
      <v-card color="primary" rounded="0" elevation="0" class="headerCard">
        <div class="titleContainer">
          <v-icon color="indigo" size="large">mdi-account-group</v-icon>
          <v-icon color="indigo">mdi-bullhorn</v-icon>
          <v-icon color="indigo" size="small" style="margin-right: 10px;">{{ {'insert': 'mdi-plus-circle', 'update': 'mdi-pencil', 'delete': 'mdi-delete'}[navigation.action] }}</v-icon>
          <h3>{{ {'insert': 'CREAR ', 'update': 'ACTUALIZAR ', 'delete': 'ELIMINAR '}[navigation.action] }}CAMPAÑA DE MARKETING{{ navigation.action != 'insert' ? ` ${navigation.CRMWhatsappMarketingCampaignID}` : ''}}</h3>
        </div>
        <div class="actionsContainer">
          <v-tooltip 
            :disabled="systemInformationData.tooltipDisabled"
            :text="navigation.fullScreen == false ? 'Mostrar en pantalla completa' : 'Salir de pantalla completa'"
            location="top"
          >
            <template v-slot:activator="{ props }">
              <v-icon
                v-bind="props"
                @click="navigation.fullScreen = !navigation.fullScreen"
                :disabled="loader.startup"
                size="x-large"
                class="hoverableVIcon"
              >
                {{ navigation.fullScreen == false ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>
            </template>
          </v-tooltip>
          <v-btn 
            @click="closeDialog()"
            :disabled="loader.startup"
            color="error" 
            class="hoverableVButton" 
          >
            <v-icon start>mdi-close-circle</v-icon>
            <p>CERRAR</p>
          </v-btn>
        </div>
      </v-card>
      <v-card color="secondary" elevation="0" rounded="0" style="width: 100%; height: 2px; flex-shrink: 0;"></v-card>
      <template v-if="loader.startup">
        <div style="flex: 1; min-height: 0; display: flex; flex-direction: column; align-items: center; justify-content: center;">
          <AppLoaderScreen
            :appLogoSize="'x-small'"
            :loadingText="navigation.action == 'insert' ? 'Cargando información para crear la campaña de marketing' : 'Cargando campaña de marketing'"
            :dotsToAnimate="3"
            style="width: 100%; height: 100%;"
          ></AppLoaderScreen>
        </div>
      </template>
      <template v-else>
        <div style="flex: 1; min-height: 0; overflow-y: auto; scrollbar-width: thin; scrollbar-color: #3F51B5 transparent; padding: 15px;">
          <template v-if="['insert', 'update'].includes(navigation.action)">
            <v-text-field
              ref="CRMWhatsappMarketingCampaignName"
              v-model="input.CRMWhatsappMarketingCampaignName"
              :loading="loader.startup || loader.action"
              :disabled="loader.startup || loader.action"
              label="Nombre de la campaña de marketing"
              prepend-inner-icon="mdi-alphabetical-variant"
              clear-icon="mdi-backspace"
              variant="outlined"
              density="compact"
              autocomplete="off"
              clearable
              hide-details
              style="margin-bottom: 15px;"
            ></v-text-field>
            <v-textarea
              v-model="input.CRMWhatsappMarketingCampaignDescription"
              :loading="loader.startup || loader.action"
              :disabled="loader.startup || loader.action"
              label="Descripción de la campaña de marketing (opcional)"
              prepend-inner-icon="mdi-text-box"
              clear-icon="mdi-backspace"
              variant="outlined"
              density="compact"
              autocomplete="off"
              rows="3"
              max-rows="3"
              no-resize
              clearable
              hide-details
              style="margin-bottom: 15px;"
            ></v-textarea>
            <v-autocomplete
              v-model="input.CRMWhatsappMarketingCampaignType"
              :items="display.CRMWhatsappMarketingCampaignType"
              :loading="loader.startup || loader.action"
              :disabled="loader.startup || loader.action"
              label="Tipo de la campaña de marketing"
              prepend-inner-icon="mdi-source-branch"
              clear-icon="mdi-backspace"
              variant="outlined"
              density="compact"
              autocomplete="off"
              chips
              closable-chips
              clearable
              hide-details
              hide-no-data
              style="margin-bottom: 15px;"
            >
              <template v-slot:chip="{ item }">
                <v-chip 
                  :color="item.raw.color"
                  elevation="2"
                  variant="flat"
                  label
                >
                  <p>{{ item.raw.title }}</p>
                  <template v-slot:close>
                    <v-icon 
                      @click="input.CRMWhatsappMarketingCampaignType = null"
                      class="hoverableVIcon"
                    >
                      mdi-close-circle
                    </v-icon>
                  </template>
                </v-chip>
              </template>
              <template v-slot:item="{ item }">
                <v-list density="compact" style="overflow: hidden; padding: 0; margin: 0;">
                  <v-list-item 
                    @click="input.CRMWhatsappMarketingCampaignType = item.value"
                    :title="null" 
                    :subtitle="null"
                    :active="input.CRMWhatsappMarketingCampaignType == item.value"
                    class="hoverableVListItem"
                  >
                    <template v-slot:prepend>
                      <v-checkbox-btn 
                        :model-value="input.CRMWhatsappMarketingCampaignType == item.value"
                        density="compact"
                        readonly
                        hide-details
                        class="hoverableVIcon"
                        style="margin-right: 10px;"
                      ></v-checkbox-btn>
                    </template>
                    <v-chip 
                      :color="item.raw.color"
                      density="dense"
                      variant="flat"
                      elevation="2"
                      label
                      style="margin-top: 5px; margin-bottom: 5px;"
                    >
                      <p>{{ item.raw.title }}</p>
                    </v-chip>
                  </v-list-item>
                </v-list>
              </template>
            </v-autocomplete>
            <v-autocomplete
              v-model="input.CRMWhatsappMarketingCampaignStatus"
              :items="display.CRMWhatsappMarketingCampaignStatus"
              :loading="loader.startup || loader.action"
              :disabled="loader.startup || loader.action"
              label="Estado de la campaña de marketing"
              prepend-inner-icon="mdi-clock"
              clear-icon="mdi-backspace"
              variant="outlined"
              density="compact"
              autocomplete="off"
              chips
              closable-chips
              clearable
              hide-details
              hide-no-data
              style="margin-bottom: 15px;"
            >
              <template v-slot:chip="{ item }">
                <v-chip 
                  :color="item.raw.color"
                  elevation="2"
                  variant="flat"
                  label
                >
                  <p>{{ item.raw.title }}</p>
                  <template v-slot:close>
                    <v-icon 
                      @click="input.CRMWhatsappMarketingCampaignStatus = null"
                      class="hoverableVIcon"
                    >
                      mdi-close-circle
                    </v-icon>
                  </template>
                </v-chip>
              </template>
              <template v-slot:item="{ item }">
                <v-list density="compact" style="overflow: hidden; padding: 0; margin: 0;">
                  <v-list-item 
                    @click="input.CRMWhatsappMarketingCampaignStatus = item.value"
                    :title="null" 
                    :subtitle="null"
                    :active="input.CRMWhatsappMarketingCampaignStatus == item.value"
                    class="hoverableVListItem"
                  >
                    <template v-slot:prepend>
                      <v-checkbox-btn 
                        :model-value="input.CRMWhatsappMarketingCampaignStatus == item.value"
                        density="compact"
                        readonly
                        hide-details
                        class="hoverableVIcon"
                        style="margin-right: 10px;"
                      ></v-checkbox-btn>
                    </template>
                    <v-chip 
                      :color="item.raw.color"
                      density="dense"
                      variant="flat"
                      elevation="2"
                      label
                      style="margin-top: 5px; margin-bottom: 5px;"
                    >
                      <p>{{ item.raw.title }}</p>
                    </v-chip>
                  </v-list-item>
                </v-list>
              </template>
            </v-autocomplete>
            <v-autocomplete
              v-model="input.CRMWhatsappMarketingCampaignCRMLocalityID"
              :items="systemInformationData.CRMLocalities"
              :loading="loader.startup || loader.action"
              :disabled="loader.startup || loader.action"
              label="Localidad de la campaña de marketing (opcional)"
              item-title="CRMLocalityName"
              item-value="CRMLocalityID"
              prepend-inner-icon="mdi-store"
              clear-icon="mdi-backspace"
              variant="outlined"
              density="compact"
              autocomplete="off"
              chips
              closable-chips
              clearable
              hide-details
              hide-no-data
              style="margin-bottom: 15px;"
            >
              <template v-slot:chip="{ item }">
                <v-chip 
                  :color="item.raw.CRMLocalityColor"
                  elevation="2"
                  variant="flat"
                  label
                >
                  <p>{{ item.raw.CRMLocalityName }}</p>
                  <template v-slot:close>
                    <v-icon 
                      @click="input.CRMWhatsappMarketingCampaignCRMLocalityID = null"
                      class="hoverableVIcon"
                    >
                      mdi-close-circle
                    </v-icon>
                  </template>
                </v-chip>
              </template>
              <template v-slot:item="{ item }">
                <v-list density="compact" style="overflow: hidden; padding: 0; margin: 0;">
                  <v-list-item 
                    @click="input.CRMWhatsappMarketingCampaignCRMLocalityID = item.value"
                    :title="null" 
                    :subtitle="null"
                    :active="input.CRMWhatsappMarketingCampaignCRMLocalityID == item.value"
                    class="hoverableVListItem"
                  >
                    <template v-slot:prepend>
                      <v-checkbox-btn 
                        :model-value="input.CRMWhatsappMarketingCampaignCRMLocalityID == item.value"
                        density="compact"
                        readonly
                        hide-details
                        class="hoverableVIcon"
                        style="margin-right: 10px;"
                      ></v-checkbox-btn>
                    </template>
                    <v-chip 
                      :color="item.raw.CRMLocalityColor"
                      density="dense"
                      variant="flat"
                      elevation="2"
                      label
                      style="margin-top: 5px; margin-bottom: 5px;"
                    >
                      <p>{{ item.raw.CRMLocalityName }}</p>
                    </v-chip>
                  </v-list-item>
                </v-list>
              </template>
            </v-autocomplete>
            <v-textarea
              v-model="input.CRMWhatsappMarketingCampaignCRMWhatsappTextMessageContent"
              :loading="loader.startup || loader.action"
              :disabled="loader.startup || loader.action"
              label="Contenido del mensaje de texto de la campaña de marketing"
              prepend-inner-icon="mdi-message-text"
              clear-icon="mdi-backspace"
              variant="outlined"
              density="compact"
              autocomplete="off"
              rows="3"
              max-rows="3"
              no-resize
              clearable
              hide-details
            ></v-textarea>
          </template>
          <template v-else>
            <div class="twoColumnContainer" style="gap: 10px;">
              <div style="display: flex; flex-direction: column; gap: 10px;">
                <div style="display: flex; gap: 5px;">
                  <v-icon color="indigo">mdi-barcode</v-icon>
                  <p><strong>ID:</strong> {{ display.CRMWhatsappMarketingCampaign.CRMWhatsappMarketingCampaignID }}</p>
                </div>
                <div style="display: flex; gap: 5px;">
                  <v-icon color="indigo">mdi-alphabetical-variant</v-icon>
                  <p><strong>Nombre:</strong> {{ display.CRMWhatsappMarketingCampaign.CRMWhatsappMarketingCampaignName }}</p>
                </div>
                <div style="display: flex; gap: 5px;">
                  <v-icon color="indigo">mdi-text-box</v-icon>
                  <template v-if="display.CRMWhatsappMarketingCampaign.CRMWhatsappMarketingCampaignDescription == null">
                    <p><strong>Descripción:</strong> <span style="font-size: x-small; color: #9e9e9e;">Sin descripción</span></p>
                  </template>
                  <template v-else>
                    <p style="max-height: 150px; overflow-y: auto; scrollbar-width: thin; scrollbar-color: #3F51B5 transparent;"><strong>Descripción:</strong> {{ display.CRMWhatsappMarketingCampaign.CRMWhatsappMarketingCampaignDescription }}</p>
                  </template>
                </div>
                <div style="display: flex; gap: 5px;">
                  <v-icon color="indigo">mdi-source-branch</v-icon>
                  <p><strong>Tipo:</strong></p>
                  <v-chip
                    :color="{'Difusión': 'teal', 'Promoción': 'info', 'Código de descuento': 'warning', 'Otro': 'blue-grey'}[display.CRMWhatsappMarketingCampaign.CRMWhatsappMarketingCampaignType]"
                    variant="flat"
                    elevation="2"
                    density="compact"
                    label
                    style="margin-left: 5px;"
                  >
                    <p>{{ display.CRMWhatsappMarketingCampaign.CRMWhatsappMarketingCampaignType }}</p>
                  </v-chip>
                </div>
                <div style="display: flex; gap: 5px; align-items: center;">
                  <v-icon color="indigo">mdi-store</v-icon>
                  <template v-if="display.CRMWhatsappMarketingCampaign.CRMWhatsappMarketingCampaignCRMLocalityID == null">
                    <p><strong>Localidad:</strong> <span style="font-size: x-small; color: #9e9e9e;">No registrada</span></p>
                  </template>
                  <template v-else>
                    <p><strong>Localidad:</strong></p>
                    <v-chip
                      :color="display.CRMWhatsappMarketingCampaign.CRMWhatsappMarketingCampaignCRMLocalityColor || 'primary'"
                      variant="flat"
                      elevation="2"
                      density="compact"
                      label
                      style="margin-left: 5px;"
                    >
                      <p>{{ display.CRMWhatsappMarketingCampaign.CRMWhatsappMarketingCampaignCRMLocalityName || 'No registrada' }}</p>
                    </v-chip>
                  </template>
                </div>
              </div>
              <div style="display: flex; flex-direction: column; gap: 10px;">
                <div style="display: flex; gap: 5px;">
                  <v-icon color="indigo">mdi-clock</v-icon>
                  <p><strong>Estado:</strong></p>
                  <v-chip
                    :color="{'Activa': 'success', 'Inactiva': 'grey', 'Finalizada': 'error'}[display.CRMWhatsappMarketingCampaign.CRMWhatsappMarketingCampaignStatus]"
                    variant="flat"
                    elevation="2"
                    density="compact"
                    label
                  >
                    <p>{{ display.CRMWhatsappMarketingCampaign.CRMWhatsappMarketingCampaignStatus }}</p>
                  </v-chip>
                </div>
                <div style="display: flex; gap: 5px;">
                  <v-icon color="indigo">mdi-message-text</v-icon>
                  <p style="max-height: 150px; overflow-y: auto; scrollbar-width: thin; scrollbar-color: #3F51B5 transparent;"><strong>Contenido del mensaje de texto:</strong> {{ display.CRMWhatsappMarketingCampaign.CRMWhatsappMarketingCampaignCRMWhatsappTextMessageContent }}</p>
                </div>
                <div style="display: flex; gap: 5px; align-items: center;">
                  <v-icon color="indigo">mdi-account-plus</v-icon>
                  <p><strong>Creación:</strong></p>
                  <v-chip
                    :color="display.CRMWhatsappMarketingCampaign.CRMWhatsappMarketingCampaignCreationCRMAgentColor || 'primary'"
                    variant="flat"
                    elevation="2"
                    label
                    style="margin-left: 5px;"
                  >
                    <div style="display: flex; align-items: center;">
                      <img
                        :src="display.CRMWhatsappMarketingCampaign.CRMWhatsappMarketingCampaignCreationCRMAgentProfilePictureURL == null ? require('@/assets/images/CRMAgentProfilePicturePlaceholder.png') : display.CRMWhatsappMarketingCampaign.CRMWhatsappMarketingCampaignCreationCRMAgentProfilePictureURL"
                        :draggable="false"
                        style="width: 25px; height: 25px; border-radius: 50%; object-fit: cover; margin-right: 10px;"
                      >
                      <div style="display: flex; flex-direction: column;">
                        <p>{{ display.CRMWhatsappMarketingCampaign.CRMWhatsappMarketingCampaignCreationCRMAgentName == null ? 'No registrado' : display.CRMWhatsappMarketingCampaign.CRMWhatsappMarketingCampaignCreationCRMAgentName }}</p>
                        <div style="display: flex; align-items: center; gap: 5px;">
                          <v-icon size="x-small">mdi-clock</v-icon>
                          <p style="font-size: x-small;">{{ $displayFunctions.default.fromDatetimeToHHMMSSDDMMYYYY(display.CRMWhatsappMarketingCampaign.CRMWhatsappMarketingCampaignCreationDatetime) }}</p>
                        </div>
                      </div>
                    </div>
                  </v-chip>
                </div>
                <div style="display: flex; gap: 5px; align-items: center;">
                  <v-icon color="indigo">mdi-account-edit</v-icon>
                  <template v-if="display.CRMWhatsappMarketingCampaign.CRMWhatsappMarketingCampaignUpdateCRMAgentID == null">
                    <p><strong>Actualización:</strong> <span style="font-size: x-small; color: #9e9e9e;">No actualizado</span></p>
                  </template>
                  <template v-else>
                    <p><strong>Actualización:</strong></p>
                    <v-chip
                      :color="display.CRMWhatsappMarketingCampaign.CRMWhatsappMarketingCampaignUpdateCRMAgentColor || 'primary'"
                      variant="flat"
                      elevation="2"
                      label
                      style="margin-left: 5px;"
                    >
                      <div style="display: flex; align-items: center;">
                        <img
                          :src="display.CRMWhatsappMarketingCampaign.CRMWhatsappMarketingCampaignUpdateCRMAgentProfilePictureURL == null ? require('@/assets/images/CRMAgentProfilePicturePlaceholder.png') : display.CRMWhatsappMarketingCampaign.CRMWhatsappMarketingCampaignUpdateCRMAgentProfilePictureURL"
                          :draggable="false"
                          style="width: 25px; height: 25px; border-radius: 50%; object-fit: cover; margin-right: 10px;"
                        >
                        <div style="display: flex; flex-direction: column;">
                          <p>{{ display.CRMWhatsappMarketingCampaign.CRMWhatsappMarketingCampaignUpdateCRMAgentName == null ? 'No registrado' : display.CRMWhatsappMarketingCampaign.CRMWhatsappMarketingCampaignUpdateCRMAgentName }}</p>
                          <div style="display: flex; align-items: center; gap: 5px;">
                            <v-icon size="x-small">mdi-clock</v-icon>
                            <p style="font-size: x-small;">{{ $displayFunctions.default.fromDatetimeToHHMMSSDDMMYYYY(display.CRMWhatsappMarketingCampaign.CRMWhatsappMarketingCampaignUpdateDatetime) }}</p>
                          </div>
                        </div>
                      </div>
                    </v-chip>
                  </template>
                </div>
              </div>
            </div>
          </template>
        </div>
        <v-card color="indigo" elevation="0" rounded="0" style="width: 100%; height: 2px; flex-shrink: 0;"></v-card>
        <v-card color="primary" elevation="0" rounded="0" style="padding: 15px; flex-shrink: 0;">
          <v-tooltip
            :disabled="validateInputForDialog(false).success == true"
            location="top"
          > 
            <template v-slot:activator="{ props }">
              <div
                v-bind="props"
                style="cursor: pointer;"
              >
                <v-btn 
                  @click="navigation.action == 'insert' ? insertCRMWhatsappMarketingCampaignFromCRMWhatsappMarketingCampaignDialog() : (navigation.action == 'update' ? updateCRMWhatsappMarketingCampaignFromCRMWhatsappMarketingCampaignDialog() : deleteCRMWhatsappMarketingCampaignFromCRMWhatsappMarketingCampaignDialog())" 
                  :disabled="loader.startup || loader.action || validateInputForDialog(false).success == false" 
                  color="indigo" 
                  block 
                  class="hoverableVButton"
                >
                  <v-icon size="large" start>mdi-account-group</v-icon>
                  <v-icon start>mdi-bullhorn</v-icon>
                  <v-icon size="small" start>{{ {'insert': 'mdi-plus-circle', 'update': 'mdi-pencil', 'delete': 'mdi-delete'}[navigation.action] }}</v-icon>
                  <h3>{{ {'insert': 'CREAR', 'update': 'ACTUALIZAR', 'delete': 'ELIMINAR'}[navigation.action] }} CAMPAÑA DE MARKETING</h3>
                </v-btn>
              </div>
            </template>
            <span style="max-width: 400px; display: block;">{{ validateInputForDialog(false).result }}</span>
          </v-tooltip>
        </v-card>
      </template>
    </v-card>
  </v-dialog>
</template>
  
<style scoped>
  .headerCard {
    padding: 15px;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    align-items: center;
    gap: 10px;
    flex-shrink: 0;
  }
  .titleContainer {
    display: flex;
    align-items: center;
  }
  .actionsContainer {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-left: auto;
  }
  .twoColumnContainer {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: 1200px) {
    .headerCard {
      grid-template-columns: repeat(1, 1fr);
    }
    .titleContainer {
      justify-content: center;
    }
    .actionsContainer {
      margin-left: 0;
      justify-content: center;
    }
    .twoColumnContainer {
      grid-template-columns: 1fr;
    }
  }
</style>

<script>
  import { systemInformation } from '@/utilities/systemInformation';
  import AppLoaderScreen from '@/components/AppLoaderScreen.vue';
  export default {
    inject: ['$generalFunctions', '$displayFunctions'],
    components:
    {
      AppLoaderScreen
    },
    data: () => 
    ({
      input: 
      {
        CRMWhatsappMarketingCampaignName: null,
        CRMWhatsappMarketingCampaignDescription: null,
        CRMWhatsappMarketingCampaignType: null,
        CRMWhatsappMarketingCampaignStatus: null,
        CRMWhatsappMarketingCampaignCRMLocalityID: null,
        CRMWhatsappMarketingCampaignCRMWhatsappTextMessageContent: null
      },
      display: 
      {
        CRMWhatsappMarketingCampaignType:
        [
          {title: 'Difusión', value: 'Difusión', color: 'teal'},
          {title: 'Promoción', value: 'Promoción', color: 'info'},
          {title: 'Código de descuento', value: 'Código de descuento', color: 'warning'},
          {title: 'Otro', value: 'Otro', color: 'blue-grey'}
        ],
        CRMWhatsappMarketingCampaignStatus:
        [
          {title: 'Activa', value: 'Activa', color: 'success'},
          {title: 'Inactiva', value: 'Inactiva', color: 'grey'},
          {title: 'Finalizada', value: 'Finalizada', color: 'error'}
        ],
        CRMWhatsappMarketingCampaign: null
      },
      navigation: 
      {
        dialogIsVisible: false,
        fullScreen: false,
        action: null,
        callbackFunction: null,
        CRMWhatsappMarketingCampaignID: null
      },
      loader: 
      {
        startup: false,
        action: false
      },
      systemInformationData: 
      {
        CRMAccountID: null,
        CRMLocalities: null,
        CRMAgent: null,
        tooltipDisabled: false,
        updateSubscription: null
      }
    }),

    methods:
    {
      async selectCRMWhatsappMarketingCampaignFromCRMWhatsappMarketingCampaignDialog(){
        const selectCRMWhatsappMarketingCampaignFromCRMWhatsappMarketingCampaignDialogRequestQuery =
        {
          'localStorage':
          {
            'CRMAccountID': this.systemInformationData.CRMAccountID
          },
          'CRMWhatsappMarketingCampaignID': this.navigation.CRMWhatsappMarketingCampaignID
        };
        const selectCRMWhatsappMarketingCampaignFromCRMWhatsappMarketingCampaignDialogResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMWhatsappMarketingCampaign/functions/selectCRMWhatsappMarketingCampaignFromCRMWhatsappMarketingCampaignDialog', selectCRMWhatsappMarketingCampaignFromCRMWhatsappMarketingCampaignDialogRequestQuery);
        if (selectCRMWhatsappMarketingCampaignFromCRMWhatsappMarketingCampaignDialogResult.success){
          this.display.CRMWhatsappMarketingCampaign = selectCRMWhatsappMarketingCampaignFromCRMWhatsappMarketingCampaignDialogResult.result;
          if (this.navigation.action == 'update'){
            this.input.CRMWhatsappMarketingCampaignName = this.display.CRMWhatsappMarketingCampaign.CRMWhatsappMarketingCampaignName;
            this.input.CRMWhatsappMarketingCampaignDescription = this.display.CRMWhatsappMarketingCampaign.CRMWhatsappMarketingCampaignDescription;
            this.input.CRMWhatsappMarketingCampaignType = this.display.CRMWhatsappMarketingCampaign.CRMWhatsappMarketingCampaignType;
            this.input.CRMWhatsappMarketingCampaignStatus = this.display.CRMWhatsappMarketingCampaign.CRMWhatsappMarketingCampaignStatus;
            this.input.CRMWhatsappMarketingCampaignCRMLocalityID = this.display.CRMWhatsappMarketingCampaign.CRMWhatsappMarketingCampaignCRMLocalityID;
            this.input.CRMWhatsappMarketingCampaignCRMWhatsappTextMessageContent = this.display.CRMWhatsappMarketingCampaign.CRMWhatsappMarketingCampaignCRMWhatsappTextMessageContent;
          }
        } else {
          this.$root.notificationDialog.showSystemNotificationDialog('selectCRMWhatsappMarketingCampaignFromCRMWhatsappMarketingCampaignDialog_error', 'error', 'Ha ocurrido un error inesperado al consultar la campaña de marketing, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, true);
          this.closeDialog();
        }
      },
      async insertCRMWhatsappMarketingCampaignFromCRMWhatsappMarketingCampaignDialog(){
        this.loader.action = true;
        if (this.validateInputForDialog(true).success){
          const insertCRMWhatsappMarketingCampaignFromCRMWhatsappMarketingCampaignDialogRequestQuery =
          {
            'localStorage':
            {
              'CRMAccountID': this.systemInformationData.CRMAccountID,
              'CRMAgentID': this.systemInformationData.CRMAgent.CRMAgentID
            },
            'CRMWhatsappMarketingCampaignName': this.input.CRMWhatsappMarketingCampaignName,
            'CRMWhatsappMarketingCampaignDescription': this.input.CRMWhatsappMarketingCampaignDescription,
            'CRMWhatsappMarketingCampaignType': this.input.CRMWhatsappMarketingCampaignType,
            'CRMWhatsappMarketingCampaignStatus': this.input.CRMWhatsappMarketingCampaignStatus,
            'CRMWhatsappMarketingCampaignCRMLocalityID': this.input.CRMWhatsappMarketingCampaignCRMLocalityID,
            'CRMWhatsappMarketingCampaignCRMWhatsappTextMessageContent': this.input.CRMWhatsappMarketingCampaignCRMWhatsappTextMessageContent
          };
          const insertCRMWhatsappMarketingCampaignFromCRMWhatsappMarketingCampaignDialogResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMWhatsappMarketingCampaign/functions/insertCRMWhatsappMarketingCampaignFromCRMWhatsappMarketingCampaignDialog', insertCRMWhatsappMarketingCampaignFromCRMWhatsappMarketingCampaignDialogRequestQuery);
          if (insertCRMWhatsappMarketingCampaignFromCRMWhatsappMarketingCampaignDialogResult.success){
            this.$root.notificationDialog.showSystemNotificationDialog('insertCRMWhatsappMarketingCampaignFromCRMWhatsappMarketingCampaignDialog_success', 'success', `Se ha creado la campaña de marketing ${insertCRMWhatsappMarketingCampaignFromCRMWhatsappMarketingCampaignDialogResult.result.CRMWhatsappMarketingCampaignID} exitosamente`, null, true);
            if (this.navigation.callbackFunction != null) this.navigation.callbackFunction();
            this.closeDialog();
          } else  this.$root.notificationDialog.showSystemNotificationDialog('insertCRMWhatsappMarketingCampaignFromCRMWhatsappMarketingCampaignDialog_error', 'error', 'Ha ocurrido un error inesperado al crear la campaña de marketing, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, true);
          this.loader.action = false;
        }
      },
      async updateCRMWhatsappMarketingCampaignFromCRMWhatsappMarketingCampaignDialog(){
        this.loader.action = true;
        if (this.validateInputForDialog(true).success){
          const updateCRMWhatsappMarketingCampaignFromCRMWhatsappMarketingCampaignDialogRequestQuery =
          {
            'localStorage':
            {
              'CRMAccountID': this.systemInformationData.CRMAccountID,
              'CRMAgentID': this.systemInformationData.CRMAgent.CRMAgentID
            },
            'CRMWhatsappMarketingCampaignID': this.navigation.CRMWhatsappMarketingCampaignID,
            'CRMWhatsappMarketingCampaignName': this.input.CRMWhatsappMarketingCampaignName,
            'CRMWhatsappMarketingCampaignDescription': this.input.CRMWhatsappMarketingCampaignDescription,
            'CRMWhatsappMarketingCampaignType': this.input.CRMWhatsappMarketingCampaignType,
            'CRMWhatsappMarketingCampaignStatus': this.input.CRMWhatsappMarketingCampaignStatus,
            'CRMWhatsappMarketingCampaignCRMLocalityID': this.input.CRMWhatsappMarketingCampaignCRMLocalityID,
            'CRMWhatsappMarketingCampaignCRMWhatsappTextMessageContent': this.input.CRMWhatsappMarketingCampaignCRMWhatsappTextMessageContent
          };
          const updateCRMWhatsappMarketingCampaignFromCRMWhatsappMarketingCampaignDialogResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMWhatsappMarketingCampaign/functions/updateCRMWhatsappMarketingCampaignFromCRMWhatsappMarketingCampaignDialog', updateCRMWhatsappMarketingCampaignFromCRMWhatsappMarketingCampaignDialogRequestQuery);
          if (updateCRMWhatsappMarketingCampaignFromCRMWhatsappMarketingCampaignDialogResult.success){
            this.$root.notificationDialog.showSystemNotificationDialog('updateCRMWhatsappMarketingCampaignFromCRMWhatsappMarketingCampaignDialog_success', 'success', `Se ha actualizado la campaña de marketing ${updateCRMWhatsappMarketingCampaignFromCRMWhatsappMarketingCampaignDialogResult.result.CRMWhatsappMarketingCampaignID} exitosamente`, null, true);
            if (this.navigation.callbackFunction != null) this.navigation.callbackFunction();
            this.closeDialog();
          } else this.$root.notificationDialog.showSystemNotificationDialog('updateCRMWhatsappMarketingCampaignFromCRMWhatsappMarketingCampaignDialog_error', 'error', 'Ha ocurrido un error inesperado al actualizar la campaña de marketing, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, true);
          this.loader.action = false;
        }
      },
      async deleteCRMWhatsappMarketingCampaignFromCRMWhatsappMarketingCampaignDialog(){
        this.loader.action = true;
        const deleteCRMWhatsappMarketingCampaignFromCRMWhatsappMarketingCampaignDialogRequestQuery =
        {
          'localStorage':
          {
            'CRMAccountID': this.systemInformationData.CRMAccountID,
            'CRMAgentID': this.systemInformationData.CRMAgent.CRMAgentID
          },
          'CRMWhatsappMarketingCampaignID': this.navigation.CRMWhatsappMarketingCampaignID
        };
        const deleteCRMWhatsappMarketingCampaignFromCRMWhatsappMarketingCampaignDialogResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMWhatsappMarketingCampaign/functions/deleteCRMWhatsappMarketingCampaignFromCRMWhatsappMarketingCampaignDialog', deleteCRMWhatsappMarketingCampaignFromCRMWhatsappMarketingCampaignDialogRequestQuery);
        if (deleteCRMWhatsappMarketingCampaignFromCRMWhatsappMarketingCampaignDialogResult.success){
          this.$root.notificationDialog.showSystemNotificationDialog('deleteCRMWhatsappMarketingCampaignFromCRMWhatsappMarketingCampaignDialog_success', 'success', `Se ha eliminado la campaña de marketing ${deleteCRMWhatsappMarketingCampaignFromCRMWhatsappMarketingCampaignDialogResult.result.CRMWhatsappMarketingCampaignID} exitosamente`, null, true);
          if (this.navigation.callbackFunction != null) this.navigation.callbackFunction();
          this.closeDialog();
        } else this.$root.notificationDialog.showSystemNotificationDialog('deleteCRMWhatsappMarketingCampaignFromCRMWhatsappMarketingCampaignDialog_error', 'error', 'Ha ocurrido un error inesperado al eliminar la campaña de marketing, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, true);
        this.loader.action = false;
      },
      validateInputForDialog(showSystemNotificationDialog){
        if (['insert', 'update'].includes(this.navigation.action)){
          const regularExpressionChecker = /\S/;
          if (this.input.CRMWhatsappMarketingCampaignName == null || !regularExpressionChecker.test(this.input.CRMWhatsappMarketingCampaignName)){
            if (showSystemNotificationDialog) this.$root.notificationDialog.showSystemNotificationDialog('validateInputForDialog_input.CRMWhatsappMarketingCampaignName == null || !regularExpressionChecker.test(this.input.CRMWhatsappMarketingCampaignName)', 'warning', 'El nombre de la campaña de marketing es obligatorio', null, false);
            return {success: false, result: 'El nombre de la campaña de marketing es obligatorio'};
          }
          if (this.input.CRMWhatsappMarketingCampaignName.length > 100){
            if (showSystemNotificationDialog) this.$root.notificationDialog.showSystemNotificationDialog('validateInputForDialog_input.CRMWhatsappMarketingCampaignName.length > 100', 'warning', 'El nombre de la campaña de marketing no puede exceder los 100 caracteres de longitud', null, false);
            return {success: false, result: 'El nombre de la campaña de marketing no puede exceder los 100 caracteres de longitud'};
          }
          if (this.input.CRMWhatsappMarketingCampaignDescription != null && !regularExpressionChecker.test(this.input.CRMWhatsappMarketingCampaignDescription)){
            if (showSystemNotificationDialog) this.$root.notificationDialog.showSystemNotificationDialog('validateInputForDialog_input.CRMWhatsappMarketingCampaignDescription != null && !regularExpressionChecker.test(this.input.CRMWhatsappMarketingCampaignDescription)', 'warning', 'En caso de querer agregar una descripción, esta debe contener al menos un carácter válido', null, false);
            return {success: false, result: 'En caso de querer agregar una descripción, esta debe contener al menos un carácter válido'};
          }
          if (this.input.CRMWhatsappMarketingCampaignDescription != null && this.input.CRMWhatsappMarketingCampaignDescription.length > 65535){
            if (showSystemNotificationDialog) this.$root.notificationDialog.showSystemNotificationDialog('validateInputForDialog_input.CRMWhatsappMarketingCampaignDescription != null && this.input.CRMWhatsappMarketingCampaignDescription.length > 65535', 'warning', 'La descripción de la campaña de marketing no puede exceder los 65535 caracteres', null, false);
            return {success: false, result: 'La descripción de la campaña de marketing no puede exceder los 65535 caracteres'};
          }
          if (this.input.CRMWhatsappMarketingCampaignType == null){
            if (showSystemNotificationDialog) this.$root.notificationDialog.showSystemNotificationDialog('validateInputForDialog_input.CRMWhatsappMarketingCampaignType == null', 'warning', 'El tipo de la campaña de marketing es obligatorio', null, false);
            return {success: false, result: 'El tipo de la campaña de marketing es obligatorio'};
          }
          if (this.input.CRMWhatsappMarketingCampaignStatus == null){
            if (showSystemNotificationDialog) this.$root.notificationDialog.showSystemNotificationDialog('validateInputForDialog_input.CRMWhatsappMarketingCampaignStatus == null', 'warning', 'El estado de la campaña de marketing es obligatorio', null, false);
            return {success: false, result: 'El estado de la campaña de marketing es obligatorio'};
          }
          if (this.input.CRMWhatsappMarketingCampaignCRMWhatsappTextMessageContent == null || !regularExpressionChecker.test(this.input.CRMWhatsappMarketingCampaignCRMWhatsappTextMessageContent)){
            if (showSystemNotificationDialog) this.$root.notificationDialog.showSystemNotificationDialog('validateInputForDialog_input.CRMWhatsappMarketingCampaignCRMWhatsappTextMessageContent == null || !regularExpressionChecker.test(this.input.CRMWhatsappMarketingCampaignCRMWhatsappTextMessageContent)', 'warning', 'El contenido del mensaje de texto de la campaña de marketing es obligatorio', null, false);
            return {success: false, result: 'El contenido del mensaje de texto de la campaña de marketing es obligatorio'};
          }
          if (this.input.CRMWhatsappMarketingCampaignCRMWhatsappTextMessageContent.length > 65535){
            if (showSystemNotificationDialog) this.$root.notificationDialog.showSystemNotificationDialog('validateInputForDialog_input.CRMWhatsappMarketingCampaignCRMWhatsappTextMessageContent.length > 65535', 'warning', 'El contenido del mensaje de texto de la campaña de marketing no puede exceder los 65535 caracteres', null, false);
            return {success: false, result: 'El contenido del mensaje de texto de la campaña de marketing no puede exceder los 65535 caracteres'};
          }
        }
        return {success: true, result: null};
      },
      async getSystemInformationData(){
        try {
          systemInformation.setGeneralFunctions(this.$generalFunctions.default);
          const systemInformationResult = await systemInformation.startup();
          if (systemInformationResult.success){
            this.systemInformationData.CRMAccountID = systemInformation.getCRMAccountID;
            this.systemInformationData.CRMLocalities = systemInformation.getCRMLocalities;
            this.systemInformationData.CRMAgent = systemInformation.getCRMAgent;
            this.systemInformationData.tooltipDisabled = systemInformation.getTooltipDisabled;
            this.systemInformationData.updateSubscription = systemInformation.subscribeToUpdate((updatedSystemInformationData) => {
              this.systemInformationData.tooltipDisabled = updatedSystemInformationData.tooltipDisabled;
            });
          } else {
            this.$root.notificationDialog.showSystemNotificationDialog('getSystemInformationData_error', 'error', 'Ha ocurrido un error inesperado al obtener la información del sistema, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, true);
          }
        } catch {
          this.$root.notificationDialog.showSystemNotificationDialog('getSystemInformationData_error', 'error', 'Ha ocurrido un error inesperado al obtener la información del sistema, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, true);
        }
      },
      async openCRMWhatsappMarketingCampaignDialog(action, callbackFunction, CRMWhatsappMarketingCampaignID){
        this.loader.startup = true;
        this.navigation.dialogIsVisible = true;
        this.navigation.action = action;
        this.navigation.callbackFunction = callbackFunction;
        this.navigation.CRMWhatsappMarketingCampaignID = CRMWhatsappMarketingCampaignID;
        await this.getSystemInformationData();
        if (['update', 'delete'].includes(action)) await this.selectCRMWhatsappMarketingCampaignFromCRMWhatsappMarketingCampaignDialog();
        if (action == 'insert') this.$generalFunctions.default.focusInput(this, 'CRMWhatsappMarketingCampaignName');
        this.loader.startup = false;
      },
      closeDialog(){
        if (this.systemInformationData.updateSubscription){
          systemInformation.unsubscribeFromUpdate(this.systemInformationData.updateSubscription);
          this.systemInformationData.updateSubscription = null;
        }
        this.navigation.dialogIsVisible = false;
        this.$emit('closeCRMWhatsappMarketingCampaignDialog');
      },
      beforeUnmount(){
        if (this.systemInformationData.updateSubscription){
          systemInformation.unsubscribeFromUpdate(this.systemInformationData.updateSubscription);
          this.systemInformationData.updateSubscription = null;
        }
        this.$emit('closeCRMWhatsappMarketingCampaignDialog');
      }
    }
  }
</script>